import React, {useState} from 'react';
import {Button, Card, ColorPicker, Form, Input, Modal, Table, theme} from "antd";
import {ColumnsType} from "antd/es/table";
import {QueryKey, useQueryClient} from "@tanstack/react-query";
import {EditOutlined} from "@ant-design/icons";
import {useCommonUseMutation, useCommonUseQuery} from "../../../../../../Common/hooks/rest/ReacQueryHook";
import {procAdminService} from "../../../../../../Common/util/ProcService";
import {formatDate} from "../../../../../../Common/util/DateUtil";
import {TB_DOCUMENT_TYPE} from "./data/TB_DOCUMENT_TYPE";

const DocumentTypeMgr: React.FC = () => {
    const { token: { colorBgContainer },} = theme.useToken();

    const queryClient = useQueryClient();
    const queryKey:QueryKey =   [`DocumentTypeMgr`];

    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;

    const mutateUpdate = useCommonUseMutation<any>(queryKey, queryClient
        , procAdminService);

    const { data, isFetching} = useCommonUseQuery<TB_DOCUMENT_TYPE[]>(
        queryKey,
        () =>procAdminService<TB_DOCUMENT_TYPE[]>("post", `${serviceCode}ADS18`, null));

    const [docTypeCode, setDocTypeCode] = useState<string>('');
    const [docTypeName, setDocTypeName] = useState<string>('');
    const [docTypeColor, setDocTypeColor] = useState<string>('');
    const [docTypeLineColor, setDocTypeLineColor] = useState<string>('');
    const [docTypeStatus, setDocTypeStatus] = useState<string>('');
    const [showConfirmBox, setShowConfirmBox] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);
    const [isModifyMode, setIsModifyMode] = useState<boolean>(false);


    const columns: ColumnsType<TB_DOCUMENT_TYPE> = [
        {
            title: '종류코드',
            dataIndex: 'docTypeCode',
            key: 'docTypeCode',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>

        },
        {
            title: '종류명',
            dataIndex: 'docTypeName',
            key: 'docTypeName',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'left', justifyContent: 'left' }}>
                    {text}
                </div>

        },
        {
            title: 'Box 색상',
            dataIndex: 'docTypeColor',
            key: 'docTypeColor',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <ColorPicker value={text}  disabled defaultValue={text}/>
                </div>

        },
        {
            title: 'Line 색상',
            dataIndex: 'docTypeLineColor',
            key: 'docTypeLineColor',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <ColorPicker value={text} disabled defaultValue={text}/>
                </div>

        },
        {
            title: '생성일자',
            key: 'firstRegTime',
            dataIndex: 'firstRegTime',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {formatDate(text)}
                </div>

        },
        {
            title: '수정일자',
            key: 'lastRegTime',
            dataIndex: 'lastRegTime',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {formatDate(text)}
                </div>
            ,
        },
        {
            title: '',
            key: 'Active',
            dataIndex: 'Active',
            render: (text, record:TB_DOCUMENT_TYPE) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button type="link" size="small" onClick={() => { openModifyModal(record); }}>수정</Button>
                    <Button type="link" size="small" onClick={() => { onDelete(record); }}>삭제</Button>
                </div>

        },

    ];


    const onDelete = (record:TB_DOCUMENT_TYPE) => {

        Modal.confirm({
            title: `${record.docTypeName}을(를) 삭제하시겠습니까?`,
            content: "주의 : 시스템에 영향이 미칠 수 있습니다.",
            open: showConfirmBox,
            okText: "확인",
            cancelText: "취소",
            onOk() {
                setShowConfirmBox(false);
                const updateParam = { method: 'post', serviceCode: `${serviceCode}ADD04`, requestBody:record }
                return mutateUpdate.mutateAsync(updateParam)
                    .catch(error => {
                        console.error(error);
                    }).finally(() => {
                    });
            },
            onCancel() {
                setShowConfirmBox(false);
            },
        });

    };



    function openRegModal()
    {
        setDocTypeCode('');
        setDocTypeName('');
        setDocTypeColor('#E0F1FF');
        setDocTypeLineColor('#25A5EC');
        setDocTypeStatus('1');
        setShowModal(true);
        setIsModifyMode(false);
    }

    function openModifyModal(recode:TB_DOCUMENT_TYPE)
    {
        setDocTypeCode(recode.docTypeCode);
        setDocTypeName(recode.docTypeName);
        setDocTypeColor(recode.docTypeColor);
        setDocTypeLineColor(recode.docTypeLineColor);
        setDocTypeStatus('1');
        setShowModal(true);
        setIsModifyMode(true);
    }

    function onSaveArchive()
    {
        const requestParam:TB_DOCUMENT_TYPE = {
            docTypeCode:docTypeCode,
            docTypeName:docTypeName,
            regUser:'',
            docTypeColor:docTypeColor,
            docTypeLineColor:docTypeLineColor,
            docTypeStatus:docTypeStatus,
        }
        Modal.confirm({
            title: `${docTypeName}을(를) 저장하시겠습니까?`,
            content: "",
            open: showConfirmBox,
            okText: "확인",
            cancelText: "취소",
            onOk() {
                setShowConfirmBox(false);
                const updateParam = { method: 'post', serviceCode: `${serviceCode}ADU11`, requestBody:requestParam }
                return mutateUpdate.mutateAsync(updateParam)
                    .catch(error => {
                        console.error(error);

                    }).finally(() => {
                        setShowModal(false);
                    });
            },
            onCancel() {
                setShowConfirmBox(false);
            },
        });
    }




    const fields = [
        { name: ['docTypeCode'], value: docTypeCode },
        { name: ['docTypeName'], value: docTypeName },
        { name: ['docTypeColor'], value: docTypeColor },
        { name: ['docTypeLineColor'], value: docTypeLineColor },
        { name: ['docTypeStatus'], value: docTypeStatus },
    ];


    return (
        <>
            <nav style={{
                margin:'0px 0px 14px 0px',
                padding:'9px 8px 9px 0px',
                height: '50px',
                display:'flex',
                justifyContent: "space-between",
                alignItems:'center',
                borderRadius: "8px", // 라운드 처리 추가
                border: '1px solid #dadada',
                background: colorBgContainer,
            }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{
                        padding: '9px 5px',
                        display:'flex',
                    }}>
                    </div>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <Button style={{marginRight:"10px"}} type={"primary"} onClick={openRegModal}>문서종류등록</Button>
                </div>
            </nav>
        <Table columns={columns}
            dataSource={data}
            rowKey="docTypeCode"
            loading={isFetching}
        />

            <Modal
                open={showModal}
                title="문서종류저장"
                onCancel={()=>{setShowModal(false)}}
                footer={[
                    <></>
                ]}
            >
                <Form
                    fields={fields}
                    name="saveArchive"
                    initialValues={{
                        remember: false,
                    }}
                    onFinish={onSaveArchive}
                >
                    <Form.Item
                        label={"문서종류코드"}
                        name="docTypeCode"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        {
                            isModifyMode ?
                                <Input
                                    readOnly
                                    prefix={<EditOutlined className="site-form-item-icon" />}
                                    placeholder="문서종류코드"
                                    value={docTypeCode}
                                    onChange={(e)=>setDocTypeCode(e.target.value)}
                                />
                                :
                                <Input
                                    prefix={<EditOutlined className="site-form-item-icon" />}
                                    placeholder="문서종류코드"
                                    value={docTypeCode}
                                    onChange={(e)=>setDocTypeCode(e.target.value)}
                                />
                        }


                    </Form.Item>
                    <Form.Item
                        label={"문서종류명"}
                        name="docTypeName"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="문서종류명"
                            value={docTypeName}
                            onChange={(e)=>setDocTypeName(e.target.value)}
                        />

                    </Form.Item>
                    <Form.Item
                        label={"Box 색상"}
                        name="docTypeColor"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <ColorPicker showText defaultValue={docTypeColor} value={docTypeColor} onChange={(value, hex)=>{ setDocTypeColor(hex)}}/>

                    </Form.Item>
                    <Form.Item
                        label={"Line색상"}
                        name="docTypeLineColor"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <ColorPicker showText defaultValue={docTypeLineColor} value={docTypeLineColor} onChange={(value, hex)=>{ setDocTypeLineColor(hex)}}/>

                    </Form.Item>
                    <Form.Item
                        label={"미리보기"}
                        name="preview"
                        rules={[
                            {
                                required : false,
                            },
                        ]}
                    >
                        <Card title=" " headStyle={{backgroundColor:`${docTypeColor}`}} style={{width:'130px', border:`1px solid ${docTypeLineColor}`}} bordered={true}>
                            <div style={{height:'30px'}}>

                            </div>
                        </Card>
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-form-button">
                            적용
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default DocumentTypeMgr;
